import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleHero from './components/ArticleHero';
import ArticleBody from './components/ArticleBody';
import RelatedPosts from './components/RelatedPosts';
import BottomCTA from '@/pages/blog/components/BottomCTA';
import { blogPostingJsonLd } from '@/components/feature/BlogPostingJsonLd';

const jsonLd = blogPostingJsonLd({
  headline: 'What Stretch Tent Size Is Suitable For Your Outdoor Event?',
  description: 'A practical sizing guide to help you choose the right stretch tent for your guest count, venue, and event type. Includes capacity charts and expert recommendations.',
  url: `${import.meta.env.VITE_SITE_URL || 'https://popprotents.com'}/blog/suitable-stretch-tent-sizes-for-your-outdoor-event`,
  datePublished: '2025-12-28',
  dateModified: '2026-06-29',
  authorName: 'Pop Pro Tents Team',
  keywords: ['stretch tent sizes', 'event tent sizing', 'tent capacity guide', 'outdoor event planning', 'wedding tent size'],
});

export default function StretchTentSizesPage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <ArticleHero />
        <ArticleBody />
        <RelatedPosts />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}